module.exports = __webpack_public_path__ + "img/YS.8955a0ec.png";